import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Flag, Check } from "lucide-react";

const PRIORITIES = [
  { key: "urgent", label: "Urgent", color: "text-red-600",     bg: "bg-red-50" },
  { key: "high",   label: "High",   color: "text-orange-600",  bg: "bg-orange-50" },
  { key: "medium", label: "Medium", color: "text-blue-600",    bg: "bg-blue-50" },
  { key: "low",    label: "Low",    color: "text-neutral-400", bg: "bg-neutral-50" },
];

export default function PriorityInline({ task, canEdit, onChange }) {
  const current = PRIORITIES.find((p) => p.key === task.priority) || PRIORITIES[2];

  const trigger = (
    <button
      disabled={!canEdit}
      onClick={(e) => e.stopPropagation()}
      className="inline-flex items-center gap-1 text-[11px] font-semibold hover:opacity-80 transition-opacity"
      data-testid={`inline-priority-${task.id}`}
    >
      <Flag className={`w-3 h-3 ${current.color}`} fill={current.key !== "low" ? "currentColor" : "none"} />
      <span className={current.color}>{current.label}</span>
    </button>
  );

  if (!canEdit) return trigger;

  return (
    <Popover>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent className="w-40 p-1" align="start" onClick={(e) => e.stopPropagation()}>
        <div className="font-mono-data text-[10px] uppercase tracking-[0.2em] text-neutral-500 px-2 py-1.5">Set priority</div>
        {PRIORITIES.map((p) => (
          <button
            key={p.key}
            onClick={(e) => { e.stopPropagation(); onChange(p.key); }}
            className="w-full flex items-center gap-2 px-2 py-1.5 rounded-sm hover:bg-neutral-100 text-left"
            data-testid={`inline-priority-option-${p.key}`}
          >
            <Flag className={`w-3 h-3 ${p.color}`} fill={p.key !== "low" ? "currentColor" : "none"} />
            <span className="text-xs font-semibold">{p.label}</span>
            {task.priority === p.key && <Check className="w-3 h-3 ml-auto text-neutral-700" />}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
